import React, { useEffect, useState } from "react";
import "./terms-privacy.css";
import Header from "../../Components/Header/Header";

function TermsAndCondition() {
  const [data, setData] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://prod-api.astrocure.co.in/api/v1/settings/terms_privacy",
        );
        const result = await response.json();
        setData(result.data);
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="topDiv">
      <Header />
      <div className="empty" />
      <div className="terms-privacy ql-editor">
        <div
          style={{ margin: "2rem 0" }}
          dangerouslySetInnerHTML={{ __html: data?.termsAndConditions }}
        />
      </div>
    </div>
  );
}

export default TermsAndCondition;
